// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__t3O7Y","image_container":"Footer_image_container__E7XIE"};